import { createRouter, createWebHashHistory } from 'vue-router'
import store from '../store/index'
import Layout from '@/layout'
import i18n from '@/locales/index'
const { t } = i18n.global

const routes = [
  {
    path:"/:catchAll(.*)",
    redirect:'/', 
    meta: { title: '' }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: { title: t('pages.loginPage') },
  },
  {
    path: '/',
    name: 'Home',
    meta: { title: t('pages.homePage'), auth: false },
    component: Layout,
  },
  {
    path: '/bi/robot',
    name: 'BiRobot',
    meta: { title: t('pages.robotMatrix'), auth: false, hide: true },
    component: () => import('@/views/bi/robot'),
  },
  {
    path: '/test',
    meta: { title: t('pages.test'), auth: false, hide: true },
    component: Layout,
    children: [
      {
        path: 'test',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/test'),
        name: '测试',
        meta: {
          title: t('pages.test'),
        }
      }
    ]
  },
  // {
  //   path: '/index',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   meta: { title: '首页', icon: 'icon-ota-zhu-ye', affix: true, auth: false},
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard'),
  //       name: '首页',
  //       meta: { 
  //         title: '首页', 
  //         icon: 'icon-ota-zhu-ye', 
  //         affix: true,
  //         auth: false
  //       }
  //     }
  //   ]
  // },
  {
    path: '/equipment',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.assetManagement'),
      icon: 'icon-ota-jiqiren',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'sale',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/equipment/sale'),
        name: '销售管理',
        meta: {
          title: t('pages.salesManagement'), 
          auth: true
        },
        children: [
          {
            path: '#',
            perms: 'sale:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: '#',
          //   perms: 'sale:add',
          //   name: '新建',
          //   meta: {
          //     title: '新建',
          //     auth: true,
          //     nocache: true
          //   },
          // },
          // {
          //   path: '#',
          //   perms: 'sale:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: 'edit',
            perms: 'sale:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: 'detail',
          //   perms: 'sale:detail',
          //   name: '查看',
          //   meta: {
          //     title: '查看',
          //     auth: true,
          //     nocache: true
          //   }
          // }
        ]
      },
      {
        path: 'robotManagement',
        component: () => import(/* webpackChunkName: "equipment" */'@/views/equipment/robot'),
        name: '机器人本体',
        meta: {
          title: t('pages.robotBody'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'robot:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'robot:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            },
          },
          // {
          //   path: '#',
          //   perms: 'robot:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: '#',
            perms: 'robot:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'robot:show',
            name: t('equipment.robot.showOTA'),
            meta: {
              title: t('equipment.robot.showOTA'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: '#',
          //   perms: 'robot:hide',
          //   name: '前端隐藏',
          //   meta: {
          //     title: '前端隐藏',
          //     auth: true,
          //     nocache: true
          //   }
          // }
        ]
      },
      {
        path: 'cabinetManagement',
        component: () => import(/* webpackChunkName: "equipment" */'@/views/equipment/cabinet'),
        name: '控制柜',
        meta: {
          title: t('pages.controlCabinet'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'cabinet:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cabinet:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            },
          },
          // {
          //   path: '#',
          //   perms: 'cabinet:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: '#',
            perms: 'cabinet:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'wxacode',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/equipment/wxacode'),
        name: '机器人小程序码',
        meta: {
          title: t('pages.robotMiniProgramCode'),
          // auth: false
          auth: true,
          nocache: true
        },
        children: [
          // {
          //   path: 'search',
          //   name: t('service.upgrade.search'),
          //   meta: {
          //     title: t('service.upgrade.search'),
          //     auth: true,
          //     nocache: true
          //   }
          // },
          // {
          //   path: '#',
          //   perms: 'cabinet:add',
          //   name: '新建',
          //   meta: {
          //     title: '新建',
          //     auth: true,
          //     nocache: true
          //   },
          // },
          // {
          //   path: '#',
          //   perms: 'cabinet:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
        ]
      },
    ]
  },
  {
    path: '/status',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.statusMonitoring'),
      icon: 'icon-ota-shebeizhuangtai',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'robotStatus',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/status/robot'),
        name: '机器人本体状态',
        meta: {
          title: t('pages.robotBody'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            name: t('service.upgrade.search'),
            perms: 'robotStatus:list',
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: '#',
          //   perms: 'cabinet:add',
          //   name: '新建',
          //   meta: {
          //     title: '新建',
          //     auth: true,
          //     nocache: true
          //   },
          // },
          // {
          //   path: '#',
          //   perms: 'cabinet:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: '#',
            perms: 'robotStatus:upgrade',
            name: t('pages.remoteUpgrade'),
            meta: {
              title: t('pages.remoteUpgrade'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      // {
      //   path: 'cabinetStatus',
      //   component: () => import('@/views/status/cabinet'),
      //   name: '控制柜状态',
      //   meta: {
      //     title: '控制柜',
      //     nocache: true
      //   }
      // },
      {
        path: 'joint',
        component : () => import(/* webpackChunkName: "equipment" */ '@/views/status/joint'),
        name: '机器人关节状态',
        meta: {
          title: t('pages.robotJoint'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'joint:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: '#',
          //   perms: 'cabinet:add',
          //   name: '新建',
          //   meta: {
          //     title: '新建',
          //     auth: true,
          //     nocache: true
          //   },
          // },
          // {
          //   path: '#',
          //   perms: 'cabinet:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: '#',
            perms: 'joint:detail',
            name: t('status.joint.jointStatusDiagram'),
            meta: {
              title: t('status.joint.jointStatusDiagram'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'jointChart',
        component : () => import(/* webpackChunkName: "equipment" */ '@/views/status/jointChart'),
        name: '关节状态图',
        meta: {
          title: t('pages.jointStatusChart'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'largeScreenM',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/status/largeScreenM'),
        name: '大屏管理',
        meta: {
          title: t('pages.largeScreenManagement'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'bigScreen:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'bigScreen:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            },
          },
          {
            path: '#',
            perms: 'bigScreen:delete',
            name: t('activity.packetjoin.delete'),
            meta: {
              title: t('activity.packetjoin.delete'),
              auth: true,
              nocache: true
            }
          },
          {
            path: 'edit',
            perms: 'bigScreen:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: 'detail',
            perms: 'bigScreen:detail',
            name: t('status.largescreenm.viewLargeScreen'),
            meta: {
              title: t('status.largescreenm.viewLargeScreen'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/event',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.eventMonitoring'),
      icon: 'icon-ota-yunyingzhongxin',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'powerOnEvent',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/event/powerOn'),
        name: '上电记录',
        meta: {
          title: t('pages.powerOnRecord'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'enableEvent',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/event/enable'),
        name: '上使能记录',
        meta: {
          title: t('pages.enableRecord'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'crashEvent',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/event/crash'),
        name: '碰撞记录',
        meta: {
          title: t('pages.collisionRecord'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'emergencyEvent',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/event/emergency'),
        name: '急停记录',
        meta: {
          title: t('pages.emergencyStopRecord'),
          auth: true,
          nocache: true
        }
      }
    ]
  },
  {
    path: '/error',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.faultTroubleshooting'),
      icon: 'icon-ota-gaojing',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'alarm',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/error/alarm'),
        name: '报警信息',
        meta: {
          title: t('pages.alarmInformation'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'error',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/error/error'),
        name: '报错信息',
        meta: {
          title: t('pages.errorInformation'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'error:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'error:download',
            name: t('error.error.latestFaultDownload'),
            meta: {
              title: t('error.error.latestFaultDownload'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'errorLog',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/error/errorLog'),
        name: '故障日志',
        meta: {
          title: t('pages.faultLog'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'errorLogOld:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLogOld:download',
            name: t('error.errorlog.faultLogDownload'),
            meta: {
              title: t('error.errorlog.faultLogDownload'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLogOld:pull',
            name: t('error.errorlog.fetchingRobotLogs'),
            meta: {
              title: t('error.errorlog.fetchingRobotLogs'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLogOld:latestDownload',
            name: t('error.error.latestFaultDownload'),
            meta: {
              title: t('error.error.latestFaultDownload'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLogOld:waitResponse',
            name: t('error.errorlog.waitingForRobotResponse'),
            meta: {
              title: t('error.errorlog.waitingForRobotResponse'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'errorLogNew',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/error/errorLogNew'),
        name: '故障日志(新)',
        meta: {
          title: t('pages.faultLogNew'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'errorLog:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLog:download',
            name: t('error.errorlog.faultLogDownload'),
            meta: {
              title: t('error.errorlog.faultLogDownload'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLog:pull',
            name: t('error.errorlog.fetchingRobotLogs'),
            meta: {
              title: t('error.errorlog.fetchingRobotLogs'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'errorLog:waitResponse',
            name: t('error.errorlog.waitingForRobotResponse'),
            meta: {
              title: t('error.errorlog.waitingForRobotResponse'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/process',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.processClone'),
      icon: 'icon-ota-yunbeifen',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'programLibrary',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/process/programLibrary'),
        name: '工艺程序库',
        meta: {
          title: t('pages.processProgramLibrary'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'program:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'program:upload',
            name: t('process.configtable.localUpload'),
            meta: {
              title: t('process.configtable.localUpload'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'program:remoteClone',
            name: t('process.configtable.remoteClone'),
            meta: {
              title: t('process.configtable.remoteClone'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'program:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'program:clone',
            name: t('process.configtable.clone'),
            meta: {
              title: t('process.configtable.clone'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'configTable',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/process/configTable'),
        name: '工艺配置表',
        meta: {
          title: t('pages.processConfigurationTable'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'cloneConfig:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cloneConfig:upload',
            name: t('process.configtable.localUpload'),
            meta: {
              title: t('process.configtable.localUpload'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cloneConfig:remoteClone',
            name: t('process.configtable.remoteClone'),
            meta: {
              title: t('process.configtable.remoteClone'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cloneConfig:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cloneConfig:clone',
            name: t('process.configtable.clone'),
            meta: {
              title: t('process.configtable.clone'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'cloningRecord',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/process/cloningRecord'),
        name: '克隆记录',
        meta: {
          title: t('pages.cloneRecord'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'cloneRecord:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'cloneRecord:createTask',
            name: t('process.cloningrecord.cloningIssued'),
            meta: {
              title: t('process.cloningrecord.cloningIssued'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/collect',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.predictiveMaintenance'),
      icon: 'icon-ota-gongyezujian-yibiaopan',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'healthScoreList',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/healthScoreList'),
        name: '健康评估',
        meta: {
          title: t('pages.healthAssessment'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'healthScoreTrend',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/healthScoreTrend'),
        name: '健康趋势',
        meta: {
          title: t('pages.healthTrend'),
          auth: true,
          nocache: true
        }
      },
      {
        path: 'taskTemplates',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/taskTemplates'),
        name: '任务模板',
        meta: {
          title: t('pages.taskTemplate'),
          auth: true,
          nocache: true
        },
        children: [
          // {
          //   path: '#',
          //   perms: 'healthTask:list',
          //   name: t('service.upgrade.search'),
          //   meta: {
          //     title: t('service.upgrade.search'),
          //     auth: true,
          //     nocache: true
          //   }
          // },
          // {
          //   path: '#',
          //   perms: 'healthTask:add',
          //   name: t('elp.filter.add'),
          //   meta: {
          //     title: t('elp.filter.add'),
          //     auth: true,
          //     nocache: true
          //   }
          // },
          // {
          //   path: '#',
          //   perms: 'healthTask:terminate',
          //   name: t('collect.tasklist.earlyTermination'),
          //   meta: {
          //     title: t('collect.tasklist.earlyTermination'),
          //     auth: true,
          //     nocache: true
          //   }
          // },
          // {
          //   path: '#',
          //   perms: 'healthTask:record',
          //   name: t('collect.tasklist.msgManagement'),
          //   meta: {
          //     title: t('collect.tasklist.msgManagement'),
          //     auth: true,
          //     nocache: true
          //   }
          // }
        ]
      },
      {
        path: 'taskList',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/taskList'),
        name: '任务管理',
        meta: {
          title: t('pages.taskManagement'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'healthTask:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'healthTask:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'healthTask:terminate',
            name: t('collect.tasklist.earlyTermination'),
            meta: {
              title: t('collect.tasklist.earlyTermination'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'healthTask:record',
            name: t('collect.tasklist.msgManagement'),
            meta: {
              title: t('collect.tasklist.msgManagement'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'messageList',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/messageList'),
        name: '报文管理',
        meta: {
          title: t('pages.messageManagement'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'healthTaskReport:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'healthTaskReport:download',
            name: t('collect.tasklist.msgDownload'),
            meta: {
              title: t('collect.tasklist.msgDownload'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'diskDetection',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/diskDetection'),
        name: '磁盘检测',
        meta: {
          title: t('pages.diskDetection'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'diskState:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'diskState:detail',
            name: t('activity.packetjoin.details'),
            meta: {
              title: t('activity.packetjoin.details'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'diskDetectionDetail',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/collect/diskDetectionDetail'),
        name: '磁盘检测详情',
        meta: {
          title: t('pages.diskDetectionDetails'),
          auth: true,
          hide: true,
        }
      }
    ]
  },
  {
    path: '/version',
    component: Layout,
    redirect: 'noRedirect',
    meta: { 
      title: t('pages.versionManagement'), 
      icon: 'icon-ota-icon_yingyongguanli', 
      auth: true,
      menu: ['side'],
      affix: true 
    },
    children: [
      {
        path: 'mapping',
        component: () => import(/* webpackChunkName: "version" */ '@/views/service/version'),
        name: '版本关联',
        meta: {
          title: t('pages.versionAssociation'),
          auth: true,
        }
      },
      {
        path: 'software',
        component: () => import(/* webpackChunkName: "version" */ '@/views/service/software'),
        name: '软件管理',
        meta: {
          title: t('pages.softwareManagement'),
          auth: true,
        }
      },
      {
        path: 'upgrade',
        component: () => import(/* webpackChunkName: "version" */ '@/views/service/upgrade'),
        name: '远程升级',
        meta: {
          title: t('pages.remoteUpgrade'),
          auth: true,
        },
        children: [
          {
            path: '#',
            perms: 'version:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'version:add',
            name: t('service.upgrade.createUpgradeTask'),
            meta: {
              title: t('service.upgrade.createUpgradeTask'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/service',
    component: Layout,
    redirect: 'noRedirect',
    meta: { 
      title: t('pages.technicalService'), 
      icon: 'icon-ota-jishufuwu1', 
      auth: true,
      menu: ['side'],
      affix: true 
    },
    children: [
      {
        path: 'workOrder',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/workOrder'),
        name: '工单管理',
        meta: {
          title: t('pages.workOrderManagement'),
          auth: true
        }
      },
      {
        path: 'ota',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/ota'),
        name: '接入OTA',
        meta: {
          title: t('pages.accessOTA'),
          auth: true
        }
      },
      {
        path: 'feedback',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/feedback'),
        name: '问题反馈',
        meta: {
          title: t('pages.problemFeedback'),
          auth: true
        }
      },
      {
        path: 'forum',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/forum'),
        name: '技术论坛',
        meta: {
          title: t('pages.technicalForum'),
          auth: true
        }
      },
      {
        path: 'virtual',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/virtual'),
        name: '虚拟体验',
        meta: {
          title: t('pages.virtualExperience'),
          auth: true
        }
      },
      {
        path: 'clue',
        component: () => import(/* webpackChunkName: "service" */ '@/views/service/clue'),
        name: '用户线索',
        meta: {
          title: t('pages.userLeads'),
          auth: true
        }
      },
    ]
  },
  {
    path: '/activity',
    component: Layout,
    meta: {
      title: t('pages.activityManagement'),
      icon: 'icon-ota-yunyingguanli',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/list'),
        name: '活动列表',
        meta: {
          title: t('pages.activityList'),
          auth: true
        }
      },
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/detail'),
        name: '活动详情',
        meta: {
          title: t('pages.activityDetails'),
          auth: true,
          hide: true,
        }
      },
      {
        path: 'review',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/review'),
        name: '展后详情',
        meta: {
          title: t('pages.postEventDetails'),
          auth: true,
          hide: true,
        }
      },
      {
        path: 'subActivity',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/subActivity'),
        name: '子活动',
        meta: {
          title: t('pages.subActivity'),
          auth: false,
          hide: true,
        }
      },
      {
        path: 'wxacode',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/wxacode'),
        name: '签到码',
        meta: {
          title: t('pages.signInCode'),
          auth: true,
        }
      },
      {
        path: 'signUp',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/signUp'),
        name: '活动报名',
        meta: {
          title: t('pages.activityRegistration'),
          auth: true,
        }
      },
      {
        path: 'signIn',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/signIn'),
        name: '活动签到',
        meta: {
          title: t('pages.activityCheckIn'),
          auth: true,
        }
      },
      {
        path: 'points',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/points'),
        name: '积分奖励',
        meta: {
          title: t('pages.pointsReward'),
          auth: true,
        }
      },
      {
        path: 'packetJoin',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/packetJoin'),
        name: '活动参与',
        meta: {
          title: t('pages.activityParticipation'),
          auth: true,
        }
      },
      {
        path: 'packetReceive',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/packetReceive'),
        name: '红包领取',
        meta: {
          title: t('pages.redPacketCollection'),
          auth: true,
        }
      },
      {
        path: 'sale',
        component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/sale'),
        name: '销售收集表',
        meta: {
          title: t('pages.salesCollectionForm'),
          auth: true,
        }
      },
    ]
  },
  {
    path: '/points',
    component: Layout,
    meta: {
      title: t('pages.pointsManagement'),
      icon: 'icon-ota-chucun',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'detail',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/detail'),
        name: '积分明细',
        meta: {
          title: t('pages.pointsDetails'),
          auth: true,
        }
      },
      {
        path: 'record',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/record'),
        name: '积分详情',
        meta: {
          title: t('pages.pointsInformation'),
          auth: true,
        }
      },
      {
        path: 'award',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/award'),
        name: '积分商品',
        meta: {
          title: t('pages.pointsProducts'),
          auth: true,
        }
      },
      {
        path: 'category',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/category'),
        name: '商品类别',
        meta: {
          title: t('pages.productCategory'),
          auth: true,
        }
      },
      {
        path: 'exchange',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/exchange'),
        name: '积分兑换',
        meta: {
          title: t('pages.pointsExchange'),
          auth: true,
        }
      },
      {
        path: 'task',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/task'),
        name: '积分任务',
        meta: {
          title: t('pages.pointsTasks'),
          auth: true,
        }
      },
      {
        path: 'referrer',
        component: () => import(/* webpackChunkName: "other" */ '@/views/points/referrer'),
        name: '推荐统计',
        meta: {
          title: t('pages.recommendationStatistics'),
          auth: true,
        }
      },
    ]
  },
  {
    path: '/visitor',
    component: Layout,
    meta: {
      title: t('pages.visitorManagement'),
      icon: 'icon-ota-quanxianshenpi',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'visitor',
        component: () => import(/* webpackChunkName: "other" */ '@/views/other/visitor'),
        name: '访客登记',
        meta: {
          title: t('pages.visitorRegistration'),
          auth: true,
        }
      }
    ]
  },
  {
    path: '/train',
    component: Layout,
    meta: {
      title: t('pages.trainingManagement'),
      icon: 'icon-ota-zhihangfankui',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'train',
        component: () => import(/* webpackChunkName: "other" */ '@/views/other/train'),
        name: '培训管理',
        meta: {
          title: t('pages.trainingManagement'),
          auth: true,
        }
      },
      {
        path: 'questionnaire',
        component: () => import(/* webpackChunkName: "other" */ '@/views/other/questionnaire'),
        name: '问卷结果',
        meta: {
          title: t('pages.questionnaireResults'),
          auth: true,
        }
      }
    ]
  },
  {
    path: '/resource',
    component: Layout,
    meta: {
      title: t('pages.resourceManagement'),
      icon: 'icon-ota-yunduanxiazai',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "other" */ '@/views/resource/list'),
        name: '资源管理',
        meta: {
          title: t('pages.resourceManagement'),
          auth: true,
        }
      },
    ]
  },
  {
    path: '/banner',
    component: Layout,
    meta: {
      title: t('pages.bannerManagement'),
      icon: 'icon-ota-changjingguanli',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'list',
        component: () => import(/* webpackChunkName: "other" */ '@/views/banner/list'),
        name: 'banner列表',
        meta: {
          title: t('pages.bannerList'),
          auth: true,
        }
      },
      {
        path: 'content',
        component: () => import(/* webpackChunkName: "other" */ '@/views/banner/content'),
        name: '内容列表',
        meta: {
          title: t('pages.contentList'),
          auth: true,
        }
      }
    ]
  },

  // {
  //   path: '/customerService',
  //   component: Layout,
  //   redirect: 'noRedirect',
  //   meta: {
  //     title: t('pages.customerService'),
  //     icon: 'icon-ota-icon_shezhi',
  //     auth: true,
  //     menu: ['side'],
  //     affix: true
  //   },
  //   children: [
  //     {
  //       path: 'application',
  //       component: () => import(/* webpackChunkName: "system" */ '@/views/customerService/application'),
  //       name: '售后服务申请',
  //       meta: {
  //         title: t('pages.requestCustomerService'),
  //         auth: true,
  //       }
  //     },
  //     {
  //       path: 'repairProgress',
  //       component: () => import(/* webpackChunkName: "system" */ '@/views/customerService/repairProgress'),
  //       name: '维修进度查询',
  //       meta: {
  //         title: t('pages.checkRepairStatus'),
  //         auth: true,
  //       }
  //     },
  //     {
  //       path: 'repairDetail',
  //       component: () => import(/* webpackChunkName: "system" */ '@/views/customerService/repairDetail'),
  //       name: '报修详情',
  //       meta: {
  //         title: t('pages.repairDetail'),
  //         auth: false,
  //       }
  //     }
  //   ]
  // },

  {
    path: '/eIoT',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.eIoT'),
      icon: 'icon-ota-jiqiren2',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'deviceConfig',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/eIoT/deviceConfig'),
        name: '设备配置',
        meta: {
          title: t('pages.deviceConfig'), 
          auth: true
        },
        children: [
          {
            path: '#',
            perms: 'deviceConfig:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: '#',
          //   perms: 'sale:add',
          //   name: '新建',
          //   meta: {
          //     title: '新建',
          //     auth: true,
          //     nocache: true
          //   },
          // },
          // {
          //   path: '#',
          //   perms: 'sale:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: 'edit',
            perms: 'deviceConfig:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          // {
          //   path: 'detail',
          //   perms: 'sale:detail',
          //   name: '查看',
          //   meta: {
          //     title: '查看',
          //     auth: true,
          //     nocache: true
          //   }
          // }
        ]
      },
      {
        path: 'taskList',
        component: () => import(/* webpackChunkName: "equipment" */ '@/views/eIoT/taskList'),
        name: 'eIoT任务管理',
        meta: {
          title: t('pages.taskManagement'), 
          auth: true
        },
        children: [
          {
            path: '#',
            perms: 'taskList:add',
            name: '新建任务',
            meta: {
              title: t('eIoT.taskList.add'),
              auth: true,
              nocache: true
            },
          },
          {
            path: '#',
            perms: 'taskList:edit',
            name: '编辑',
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'taskList:detail',
            name: '查看',
            meta: {
              title: '查看',
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'taskList:earlyTermination',
            name: "提前终止",
            meta: {
              title: t('collect.tasklist.earlyTermination'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'taskList:viewUploadedData',
            name: "已传数据",
            meta: {
              title: t('eIoT.deviceConfig.viewUploadedData'),
              auth: true,
              nocache: true
            }
          },
        ]
      },
      {
        path: 'transmitting',
        component: () => import(/* webpackChunkName: "equipment" */'@/views/eIoT/transmitting'),
        name: '在传数据',
        meta: {
          title: t('pages.transmitting'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'transmitting:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'transmitting:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            },
          },
          // {
          //   path: '#',
          //   perms: 'robot:delete',
          //   name: '删除',
          //   meta: {
          //     title: '删除',
          //     auth: true,
          //     nocache: true
          //   }
          // },
          {
            path: '#',
            perms: 'transmitting:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'transmitting:show',
            name: t('equipment.robot.showOTA'),
            meta: {
              title: t('equipment.robot.showOTA'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'transmitted',
        component: () => import(/* webpackChunkName: "equipment" */'@/views/eIoT/transmitted'),
        name: '已传数据',
        meta: {
          title: t('pages.transmitted'),
          auth: true,
          nocache: true
        },
        children: [
          {
            path: '#',
            perms: 'transmitted:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'transmitted:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            },
          },
          {
            path: '#',
            perms: 'transmitted:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/smartRouting',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.smartInteraction'),
      icon: 'icon-ota-zhinengjiaohu',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'voiceLibrary',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/smartRouting/voiceLibrary'),
        name: '音色库',
        meta: {
          title: t('pages.voiceLibrary'), 
          auth: true
        },
        // children: [
        //   {
        //     path: '#',
        //     perms: 'deviceConfig:list',
        //     name: t('service.upgrade.search'),
        //     meta: {
        //       title: t('service.upgrade.search'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   // {
        //   //   path: '#',
        //   //   perms: 'sale:add',
        //   //   name: '新建',
        //   //   meta: {
        //   //     title: '新建',
        //   //     auth: true,
        //   //     nocache: true
        //   //   },
        //   // },
        //   // {
        //   //   path: '#',
        //   //   perms: 'sale:delete',
        //   //   name: '删除',
        //   //   meta: {
        //   //     title: '删除',
        //   //     auth: true,
        //   //     nocache: true
        //   //   }
        //   // },
        //   {
        //     path: 'edit',
        //     perms: 'deviceConfig:edit',
        //     name: t('activity.list.edit'),
        //     meta: {
        //       title: t('activity.list.edit'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   // {
        //   //   path: 'detail',
        //   //   perms: 'sale:detail',
        //   //   name: '查看',
        //   //   meta: {
        //   //     title: '查看',
        //   //     auth: true,
        //   //     nocache: true
        //   //   }
        //   // }
        // ]
      },
      {
        path: 'actionLibrary',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/smartRouting/actionLibrary'),
        name: '动作库',
        meta: {
          title: t('pages.actionLibrary'), 
          auth: true
        },
        // children: [
        //   {
        //     path: '#',
        //     perms: 'taskList:add',
        //     name: '新建任务',
        //     meta: {
        //       title: t('eIoT.taskList.add'),
        //       auth: true,
        //       nocache: true
        //     },
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:edit',
        //     name: '编辑',
        //     meta: {
        //       title: t('activity.list.edit'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:detail',
        //     name: '查看',
        //     meta: {
        //       title: '查看',
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:earlyTermination',
        //     name: "提前终止",
        //     meta: {
        //       title: t('collect.tasklist.earlyTermination'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
          
        // ]
      },
      {
        path: 'danceLibrary',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/smartRouting/danceLibrary'),
        name: '舞种库',
        meta: {
          title: t('pages.danceLibrary'), 
          auth: true
        },
        // children: [
        //   {
        //     path: '#',
        //     perms: 'taskList:add',
        //     name: '新建任务',
        //     meta: {
        //       title: t('eIoT.taskList.add'),
        //       auth: true,
        //       nocache: true
        //     },
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:edit',
        //     name: '编辑',
        //     meta: {
        //       title: t('activity.list.edit'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:detail',
        //     name: '查看',
        //     meta: {
        //       title: '查看',
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'taskList:earlyTermination',
        //     name: "提前终止",
        //     meta: {
        //       title: t('collect.tasklist.earlyTermination'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
          
        // ]
      },
      {
        path: 'mapManagement',
        component: () => import(/* webpackChunkName: "smartRouting" */'@/views/smartRouting/mapManagement'),
        name: '地图管理',
        meta: {
          title: t('pages.mapCenter'),
          auth: true,
          nocache: true
        },
        // children: [
        //   {
        //     path: '#',
        //     perms: 'transmitting:list',
        //     name: t('service.upgrade.search'),
        //     meta: {
        //       title: t('service.upgrade.search'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'transmitting:add',
        //     name: t('elp.filter.add'),
        //     meta: {
        //       title: t('elp.filter.add'),
        //       auth: true,
        //       nocache: true
        //     },
        //   },
        //   // {
        //   //   path: '#',
        //   //   perms: 'robot:delete',
        //   //   name: '删除',
        //   //   meta: {
        //   //     title: '删除',
        //   //     auth: true,
        //   //     nocache: true
        //   //   }
        //   // },
        //   {
        //     path: '#',
        //     perms: 'transmitting:edit',
        //     name: t('activity.list.edit'),
        //     meta: {
        //       title: t('activity.list.edit'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'transmitting:show',
        //     name: t('equipment.robot.showOTA'),
        //     meta: {
        //       title: t('equipment.robot.showOTA'),
        //       auth: true,
        //       nocache: true
        //     }
        //   }
        // ]
      },
      {
        path: 'deliveryRecord',
        component: () => import(/* webpackChunkName: "smartRouting" */'@/views/smartRouting/deliveryRecord'),
        name: '下发记录',
        meta: {
          title: t('pages.deliveryRecords'),
          auth: true,
          nocache: true
        },
        // children: [
        //   {
        //     path: '#',
        //     perms: 'transmitting:list',
        //     name: t('service.upgrade.search'),
        //     meta: {
        //       title: t('service.upgrade.search'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'transmitting:add',
        //     name: t('elp.filter.add'),
        //     meta: {
        //       title: t('elp.filter.add'),
        //       auth: true,
        //       nocache: true
        //     },
        //   },
        //   // {
        //   //   path: '#',
        //   //   perms: 'robot:delete',
        //   //   name: '删除',
        //   //   meta: {
        //   //     title: '删除',
        //   //     auth: true,
        //   //     nocache: true
        //   //   }
        //   // },
        //   {
        //     path: '#',
        //     perms: 'transmitting:edit',
        //     name: t('activity.list.edit'),
        //     meta: {
        //       title: t('activity.list.edit'),
        //       auth: true,
        //       nocache: true
        //     }
        //   },
        //   {
        //     path: '#',
        //     perms: 'transmitting:show',
        //     name: t('equipment.robot.showOTA'),
        //     meta: {
        //       title: t('equipment.robot.showOTA'),
        //       auth: true,
        //       nocache: true
        //     }
        //   }
        // ]
      },
      {
        path: 'atomicSkillLibrary',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/smartRouting/atomicSkillLibrary'),
        name: '原子技能库',
        meta: {
          title: '原子技能库', 
          auth: true
        }
      },
      {
        path: 'characterLibrary',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/smartRouting/characterLibrary'),
        name: '人物库',
        meta: {
          title: '人物库', 
          auth: true
        }
      },
    ]
  },
  {
    path: '/opsManagement',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: "运维管理",
      icon: 'icon-ota-zhinengjiaohu',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'deviceModels',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/opsManagement/deviceModels'),
        name: '机型管理',
        meta: {
          title: '机型管理',
          auth: true
        },
      },
      {
        path: 'embodiedRobots',
        component: () => import(/* webpackChunkName: "smartRouting" */ '@/views/opsManagement/embodiedRobots'),
        name: '具身监控',
        meta: {
          title: '具身监控',
          auth: true
        },
      },
    ]
  },
  {
    path: '/system',
    component: Layout,
    redirect: 'noRedirect',
    meta: {
      title: t('pages.systemSettings'),
      icon: 'icon-ota-icon_shezhi',
      auth: true,
      menu: ['side'],
      affix: true
    },
    children: [
      {
        path: 'role',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/role'),
        name: '角色管理',
        meta: {
          title: t('pages.roleManagement'),
          auth: true,
        },
        children: [
          {
            path: '#',
            perms: 'role:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'role:add',
            name: t('elp.filter.add'),
            meta: {
              title: t('elp.filter.add'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'role:edit',
            name: t('activity.list.edit'),
            meta: {
              title: t('activity.list.edit'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'role:setMenu',
            name: t('system.role.editMenu'),
            meta: {
              title: t('system.role.editMenu'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      // {
      //   path: 'menu',
      //   component: () => import(/* webpackChunkName: "system" */ '@/views/system/menu'),
      //   name: '菜单管理',
      //   meta: {
      //     title: t('pages.roleManagement'),
      //     auth: true,
      //   },
      //   children: [
      //     {
      //       path: '#',
      //       perms: 'role:add',
      //       name: '新建',
      //       meta: {
      //         title: '新建',
      //         auth: true,
      //         nocache: true
      //       }
      //     },
      //     {
      //       path: '#',
      //       perms: 'role:edit',
      //       name: '编辑',
      //       meta: {
      //         title: '编辑',
      //         auth: true,
      //         nocache: true
      //       }
      //     },
      //     {
      //       path: '#',
      //       perms: 'role:setMenu',
      //       name: '授权',
      //       meta: {
      //         title: '授权',
      //         auth: true,
      //         nocache: true
      //       }
      //     }
      //   ]
      // },
      {
        path: 'user',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/user'),
        name: '用户管理',
        meta: {
          title: t('pages.userManagement'),
          auth: true,
        },
        children: [
          {
            path: '#',
            perms: 'user:list',
            name: t('service.upgrade.search'),
            meta: {
              title: t('service.upgrade.search'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:export',
            name: t('points.exchange.exportTable'),
            meta: {
              title: t('points.exchange.exportTable'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:add',
            name: t('system.user.createUser'),
            meta: {
              title: t('system.user.createUser'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:resetPass',
            name: t('system.user.resetPassword'),
            meta: {
              title: t('system.user.resetPassword'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:proxyLogin',
            name: t('system.user.proxyLogin'),
            meta: {
              title: t('system.user.proxyLogin'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:setRole',
            name: t('system.user.modifyRole'),
            meta: {
              title: t('system.user.modifyRole'),
              auth: true,
              nocache: true
            }
          },
          {
            path: '#',
            perms: 'user:forbid',
            name: t('system.user.disable'),
            meta: {
              title: t('system.user.disable'),
              auth: true,
              nocache: true
            }
          }
        ]
      },
      {
        path: 'authority',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/authority'),
        name: '机器人权限列表',
        meta: {
          title: t('pages.robotPermissionList'),
          auth: true,
        }
      },
      {
        path: 'authApply',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/authApply'),
        name: '机器人权限审批',
        meta: {
          title: t('pages.robotPermissionApproval'),
          auth: true,
        }
      },
      {
        path: 'emailNotice',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/emailNotice'),
        name: '邮件配置',
        meta: {
          title: t('pages.emailConfiguration'),
          auth: true,
        }
      },
      {
        path: 'emailList',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/emailList'),
        name: '邮件日志',
        meta: {
          title: t('pages.emailLog'),
          auth: true,
        }
      },
      {
        path: 'logList',
        component: () => import(/* webpackChunkName: "system" */ '@/views/system/logList'),
        name: '日志管理',
        meta: {
          title: t('pages.logManagement'),
          auth: true,
        }
      }
    ]
  }
]

// const menus = []
// routes.map((route) => {
//   // 需要授权
//   if (route.meta.auth && !route.meta.hide) {
//     let menu = {
//       path: route.path,
//       label: route.meta.title,
//       children: []
//     }
//     route.children.forEach((sub) => {
//       menu.children.push({
//         path: menu.path+'/'+sub.path,
//         label: sub.meta.title,
//       })
//     })
//     menus.push(menu)
//   }
// })

const menus = routes.reduce((acc, r) => {
  if (!r.meta?.auth || r.meta?.hide) return acc
  
  const children = (r.children || []).reduce((subAcc, s) => {
    if (!s.meta?.auth) return subAcc
    
    const third = (s.children || []).filter(t => t.meta?.auth && !t.meta?.hide)
      .map(t => ({
        path: `${t.perms}`,
        label: t.meta.title,
        name: t.name,
        perms: t.perms
      }))
    
    if (third.length || !s.meta?.hideWhenNoChildren) {
      subAcc.push({
        path: `${r.path}/${s.path}`,
        label: s.meta.title,
        children: third,
        perms: `${r.path}/${s.path}`
      })
    }
    
    return subAcc
  }, [])
  
  if (children.length) {
    acc.push({
      path: r.path,
      label: r.meta.title,
      children,
      perms: r.path
    })
  }
  
  return acc
}, [])

const router = createRouter({
  history: createWebHashHistory(),
  routes: routes,
  scrollBehavior: () => ({ y: 0 })
})

function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

router.beforeEach((to) => {
  // admin
  // const userInfo = window.sessionStorage.getItem('userInfo') || '[]'
  // if (JSON.parse(userInfo).includes('admin')) return true
  // 权限校验
  if (to.meta && to.meta.auth) {
    let menus = store.state.menus
    for (let menu of menus) {
      if (menu.path === to.path) return true
      for (let sub of menu.children||[]) {
        if (sub.path === to.path) return true
      }
    }
    return { path: '/' }
  } else {
    return true
  }
})
export default router
export {
  routes,
  menus,
  resetRouter
}
